import { createContext, type ReactNode, useContext } from "react";

import type { DocumentsHubServices } from "./types.js";

const DocumentsHubContext = createContext<DocumentsHubServices | null>(null);

export function DocumentsHubProvider({
  value,
  children,
}: {
  value: DocumentsHubServices;
  children: ReactNode;
}) {
  return <DocumentsHubContext.Provider value={value}>{children}</DocumentsHubContext.Provider>;
}

/**
 * Read the hub-injected `DocumentsHubServices` port (ADR-0101 Phase 4).
 * Every Documents component that needs a hub-owned domain (auth, sharing,
 * engagement/portal grants, tenants, workspaces, Ask Insights) calls this
 * instead of importing `packages/web/src/**` directly.
 */
export function useDocumentsHub(): DocumentsHubServices {
  const ctx = useContext(DocumentsHubContext);
  if (!ctx) {
    throw new Error("useDocumentsHub must be used within <DocumentsHubProvider>");
  }
  return ctx;
}
